/* eslint-disable no-unused-vars */
import * as mm from '../../../services/memberManagement';

export default {
  namespace: 'dgcl',

  state: {
    inputItemConfigLog: null,
  },

  effects: {
    // 获取入参配置列表
    *inputItemConfigLog({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(mm.inputItemConfigLog, values);
      yield put({
        type: 'save',
        payload: {
          inputItemConfigLog: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
